import { Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { isModuleInvoice, moduleEntryPath, moduleLabel } from "./moduleLinks";

const ModuleInvoiceSourceChip = ({ invoice, prefix = "" }) => {
  const navigate = useNavigate();
  if (!isModuleInvoice(invoice)) return null;
  const path = moduleEntryPath(invoice.moduleType, invoice.moduleId);
  return (
    <Chip
      size="small"
      color="info"
      variant="outlined"
      label={`${prefix}${moduleLabel(invoice.moduleType)}`}
      onClick={
        path
          ? (event) => {
              event.stopPropagation();
              navigate(path);
            }
          : undefined
      }
    />
  );
};

export default ModuleInvoiceSourceChip;
